import http from "@/settings/apiSettings"

function authHeader() {
  return { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") };
}

class PORTAL_DecontService {
  getMele(): Promise<any> {
    return http.clientPortalHR.get("/portal/decont", { headers: authHeader() });
  }

  getById(id: string): Promise<any> {
    return http.clientPortalHR.get(`/portal/decont/${id}`, { headers: authHeader() });
  }

  getDetalii(id: string): Promise<any> {
    return http.clientPortalHR.get(`/portal/decont/${id}/detalii`, { headers: authHeader() });
  }

  creeaza(data: { ProiectID?: string | null; Explicatie: string }): Promise<any> {
    return http.clientPortalHR.post("/portal/decont", data, { headers: authHeader() });
  }

  adaugaLinie(id: string, linie: {
    TipID: string;
    Numar?: string;
    PartenerID?: string | null;
    PartenerNume?: string;
    NuExistaPartener: boolean;
    Total: number;
    ValutaID?: string | null;
    Explicatie?: string;
    files?: File[];
  }): Promise<any> {
    const fd = new FormData();
    fd.append("TipID", linie.TipID);
    if (linie.Numar) fd.append("Numar", linie.Numar);
    if (linie.PartenerID) fd.append("PartenerID", linie.PartenerID);
    if (linie.PartenerNume) fd.append("PartenerNume", linie.PartenerNume);
    fd.append("NuExistaPartener", String(linie.NuExistaPartener));
    fd.append("Total", String(linie.Total));
    if (linie.ValutaID) fd.append("ValutaID", linie.ValutaID);
    if (linie.Explicatie) fd.append("Explicatie", linie.Explicatie);
    if (linie.files) {
      for (const f of linie.files) fd.append("files", f);
    }
    return http.clientPortalHR.post(`/portal/decont/${id}/linie`, fd, { headers: authHeader() });
  }

  stergeLinie(lineId: string): Promise<any> {
    return http.clientPortalHR.delete(`/portal/decont/linie/${lineId}`, { headers: authHeader() });
  }

  trimite(id: string): Promise<any> {
    return http.clientPortalHR.post(`/portal/decont/${id}/trimite`, {}, { headers: authHeader() });
  }

  getDeAprobat(): Promise<any> {
    return http.clientPortalHR.get("/portal/decont/de-aprobat", { headers: authHeader() });
  }

  aproba(id: string, observatie?: string): Promise<any> {
    return http.clientPortalHR.post(`/portal/decont/${id}/aproba`, { Observatie: observatie }, { headers: authHeader() });
  }

  respinge(id: string, observatie?: string): Promise<any> {
    return http.clientPortalHR.post(`/portal/decont/${id}/respinge`, { Observatie: observatie }, { headers: authHeader() });
  }

  getTipuri(): Promise<any> {
    return http.clientPortalHR.get("/portal/decont/tipuri", { headers: authHeader() });
  }

  getValute(): Promise<any> {
    return http.clientPortalHR.get("/portal/decont/valute", { headers: authHeader() });
  }

  getParteneri(): Promise<any> {
    return http.clientPortalHR.get("/portal/decont/parteneri", { headers: authHeader() });
  }

  getProiecte(): Promise<any> {
    return http.clientPortalHR.get("/portal/decont/proiecte", { headers: authHeader() });
  }
}

export default new PORTAL_DecontService();
